const listAttributes = [
  'subject',
  'type',
  'creationDatetime',
  'editDatetime',
  'label',
  'unitPayDuration',
  'unitPayRate',
] as const;

const getAttributes = [...listAttributes] as const;

export const LegacyExamTypeAttributes = {
  List: listAttributes,
  Get: getAttributes,
};
